import { OptionData, QuestionSummary } from '@nexxt/common/types';
import * as React from 'react';
import { IRules } from '../../../../../../../interface/conditions.interface';
import IncaVariableEvalEditor from '../../../../../../common/IncaVariable/IncaVariableEvalEditor';
interface OptionConditionRuleProps {
    className?: string;
    rule?: IRules;
    isEdit: boolean;
    errorObject?: any;
    option?: OptionData;
    showError: boolean;
    disabled?: boolean;
    questionSummaries: QuestionSummary[];
    handleQuestionSelect: (questionSummary: QuestionSummary) => void;
    handleOptionSelect: (type, option, compareType?) => void;
    handleOperatorSelect: (operator) => void;
}

const OptionConditionRule: React.FC<OptionConditionRuleProps> = ({
    className,
    isEdit,
    rule,
    showError,
    errorObject,
    handleQuestionSelect,
    handleOptionSelect,
    handleOperatorSelect,
    questionSummaries,
    disabled
}: OptionConditionRuleProps) => {
    return (
        <IncaVariableEvalEditor
            isEdit={isEdit}
            rule={rule}
            disabled={disabled}
            className={className}
            questionSummaries={questionSummaries}
            showError={showError}
            errorObject={errorObject}
            handleQuestionSelect={handleQuestionSelect}
            handleVariableFunctionSelect={handleOperatorSelect}
            handleOptionSelect={(type, option, compareType) =>
                handleOptionSelect(type, option, compareType)
            }
        />
    );
};

export default OptionConditionRule;
